import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import GameSetupShell, { LevelStart, RunHeader, TileGrid, useGameStats } from '../../components/Games2/GameSetupShell';

const LEVELS = [
  { id: 1, name: 'Level 1', description: 'Practice (Slow)', feedback: true, color: 'green', totalRounds: 20, details: ['20 rounds', 'Slow speed (8s per round)', 'Feedback enabled', 'Practice mode'] },
  { id: 2, name: 'Level 2', description: 'Training (Medium)', feedback: false, color: 'yellow', totalRounds: 20, details: ['20 rounds', 'Medium speed (6s per round)', 'No feedback', 'Training mode'] },
  { id: 3, name: 'Level 3', description: 'Real Test (Fast)', feedback: false, color: 'rose', totalRounds: 20, details: ['20 rounds', 'Fast speed (4s per round)', 'No feedback', 'Real exam conditions'] },
];

const score = (r) => parseFloat(r.final_score) || 0;

const OWTSetup2 = () => {
  const { subjectId } = useParams();
  const navigate = useNavigate();
  const game = useGameStats('OWT', subjectId);
  const { stats } = game;
  const [level, setLevel] = useState(3);

  const start = () => {
    const l = LEVELS.find((x) => x.id === level);
    navigate(`/games/owt/${subjectId}/play`, { state: { level, feedback: l.feedback, totalRounds: l.totalRounds, subject: stats?.subject } });
  };

  return (
    <GameSetupShell
      code="OWT"
      name="Perceptual Speed"
      description="Perceptual speed assessment game"
      game={game}
      heroStats={[
        { label: 'Runs', value: stats?.total_runs || 0 },
        { label: 'Best', value: `${stats?.best_score || 0}%` },
        { label: 'Average', value: `${stats?.average_score || 0}%` },
      ]}
      picker={<LevelStart levels={LEVELS} value={level} onChange={setLevel} onStart={start} />}
      runs={stats?.history || []}
      chart={{ series: [{ label: 'Score', color: '#10B981', value: score, main: true }], max: 100, suffix: '%' }}
      renderRun={(run) => (
        <div className="space-y-4">
          <RunHeader run={run} level={run.level || 1} score={`${score(run).toFixed(1)}%`} scoreLabel={`${run.correct_count}/${run.total_rounds * 4} answers correct`} />
          {(run.rounds_data || []).length > 0 && (
            <TileGrid
              title="Round results"
              items={run.rounds_data.map((r, i) => {
                const rc = r.correctCount || 0;
                return { label: `R${i + 1}`, value: `${rc}/4`, tone: rc === 4 ? 'good' : rc >= 2 ? 'mid' : 'bad' };
              })}
            />
          )}
        </div>
      )}
    />
  );
};

export default OWTSetup2;
